import { cn } from '@/shared/lib/utils';
import { Text } from '../../text';
import { RequiredLabel } from '../required-label/RequiredLabel';

type FormControlLabelProps = {
  label: string | null;
  showRequired?: boolean;
  showSupportText?: boolean;
  supportText?: string | undefined;
  htmlFor?: string;
  className?: string;
};

export const FormControlLabel = ({
  label,
  showRequired = false,
  showSupportText = false,
  supportText,
  htmlFor,
  className,
}: FormControlLabelProps) => {
  if (!label && !showSupportText && !showRequired) {
    return null;
  }
  return (
    <div className={cn('flex w-full flex-col gap-1', className)}>
      <div className="flex items-center gap-2">
        {label && (
          <Text htmlFor={htmlFor} variant="label">
            {label}
          </Text>
        )}
        {showRequired && <RequiredLabel />}
      </div>
      {showSupportText && supportText && <Text variant="description">{supportText}</Text>}
    </div>
  );
};
